module.exports = __webpack_public_path__ + "img/Scala.37229d4a.png";